import React, { useEffect, useState } from "react";
import "./Home.css";
import img1 from "./images/bgx0.jpg"
import imgg1 from "./images/bg552.jpg"
import imgg from "./images/bgx11.jpg"
import Product from "./Product";
import Header from "./Header";
import { useUserAuth } from './UserAuthContext';
import imag from "./images/p1.jpg"
import imag1 from "./images/p2.jpg"
import imag2 from "./images/p3.jpg"
import imag3 from "./images/p5.jpg"
import imag4 from "./images/p6.jpg"
import imag5 from "./images/p7.jpg"
import imag6 from "./images/p8.jpg"
import imag7 from "./images/p9.jpg"
import imag8 from "./images/p4.jpg"


function Home() {
  const slideshowImages = [img1, imgg, imgg1];
  const [currentSlide, setCurrentSlide] = useState(0);
  const { user } = useUserAuth();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === slideshowImages.length - 1 ? 0 : prevSlide + 1
      );
    }, 2000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="home">
      <div className="home__container">
        
        <Header/>


        <img
          className="home__image"
          src={slideshowImages[currentSlide]}
          alt=""
        />
        <div className="welcome">
          {user ? (
            <p><span className = "reddish">Welcome,</span> {user.displayName}!</p>
          ) : (
            <p>Welcome to our store!</p>
          )}
        </div>

        <div className="home__row">
          <Product
            id="A1"
            title="Royal Pink Double-Breasted Blazer | Firestore"
            price={4999}
            rating={5}
            image={imag8}
          />
          <Product
            id="B2"
            title="Grey Japanese Fiber Linen Suit | Firestore Special Edition"
            price={13999.0}
            rating={4}
            image={imag1}
          />
         
        </div>

        
        <div className="home__row">
        <Product
            id="C3"
            title="Hawaii Jumper Green sweatshirt | Firestore Special Edition"
            price={4999}
            rating={5}
            image="https://i.pinimg.com/originals/0b/a4/99/0ba4995068d01b42caa18b7cd9ffe68d.jpg"
          /> 
                  <Product
            id="A4"
            title="Slim Fit Blood Red Suit | Fiberstore"
            price={13499.0}
            rating={4}
            image={imag}
          />
         
        </div>

         <div className="home__row">

          <Product
            id="B5"
            title="Skeleton Print Drop Shoulder Zipper Hoodie | FiberStore"
            price={1999}
            rating={4}
            image="https://img.ltwebstatic.com/images3_pi/2021/09/27/16327330018bcefaabf1e534cfdcc577d08538cc08_thumbnail_750x.webp"
          />
                          <Product
            id="A6"
            title="Floral Black Printed Shirt | FiberStore AP Dhillon Edition"
            price={5699}
            rating={5}
            image="https://wallpapercave.com/wp/wp8829386.jpg"
          />
          </div>


        <div className="home__row">
        <Product
            id="A7"
            title="White Casual Printed Shirt for Women by FiberStore"
            price={2399.0}
            rating={4}
            image="https://assets.ajio.com/medias/sys_master/root/20220927/gbFr/6333285ff997dd1f8d20870f/-473Wx593H-469278586-white-MODEL4.jpg"
          />
                    <Product
            id="A8"
            title="Influencer Series Men Printed Shirt From FiberStore"
            price={1699}
            rating={5}
            image="https://assets.myntassets.com/assets/images/21617996/2023/1/19/5c8eb4a7-50ef-46a3-9a12-5069559600fb1674135860723BlackInfluencePrintOversizeDropShoulderShirt1.jpg"
          />

        </div>

        <div className="home__row">
        <Product
            id="B10"
            title="Pink Long Full Sleeves Dress | FS Banita Sandhu Edition"
            price={9899}
            rating={5}
            image="https://www.k4fashion.com/wp-content/uploads/2023/02/banita-sandhu-aces-pink-rauched-long-full-sleeves-dress-678x1024.jpg"
          />
          <Product
            id="C11"
              title="FiberStore Brand Print Hoodie with Kangaroo Pocket For Men | FiberStore"
            price={4999}
            rating={5}
            image="https://assets.ajio.com/medias/sys_master/root/20221114/bwTX/63727a4daeb269659c8c5c10/-473Wx593H-469332953-navy-MODEL.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="C12"
            title="Charcoal Grey Two-Piece Suit | Fibre Store"
            price={4999}
            rating={5}
            image={imag2}
          />
          <Product
            id="C13"
            title="Sky Blue Japanese Fiber Windowpane Suit | Firestore"
            price={11999.0}
            rating={4}
            image={imag6}
          />
        </div>

        
        <div className="home__row">
        <Product
            id="A9"
            title="Qutie Slogan Graphic Drop Shoulder Hoodie| FiberStore"
            price={2899}
            rating={5}
            image="https://img.ltwebstatic.com/images3_pi/2022/05/31/16539821481f99a2169058ea9f6ab49d3626a4fa9d_thumbnail_720x.webp"
          />
          <Product
            id="B14"
            title="Blue Floral skirt From FibreStore"
            price={2999}
            rating={5}
            image="https://assets.ajio.com/medias/sys_master/root/20230620/BVTA/6491ea0fd55b7d0c637ce77b/-473Wx593H-463086147-blue-MODEL.jpg"
          />
         
        </div>

        <div className="home__row">
          <Product
            id="A15"
            title="NY Design Leather Jacket From FibreStore"
            price={4999}
            rating={5}
            image="https://m.media-amazon.com/images/I/71lTlEsWFaL._UY741_.jpg"
          />
                    <Product
            id="C16"
            title="Graphic Print Hoodie with Kangaroo Pocket From FibreStore"
            price={3299}
            rating={4}
            image="https://assets.ajio.com/medias/sys_master/root/20230621/CjLJ/64929794d55b7d0c63920b12/-473Wx593H-464243946-white-MODEL.jpg"
          />
         

        </div>

        <div className="home__row">
          <Product
            id="C17"
            title="Beige Double-Breasted Blazer | Firestore"
            price={14999}
            rating={5}
            image={imag3}
          />
          <Product
            id="B18"
            title="Magenta Tweed Three-Piece Suit | Firestore"
            price={12999.0}
            rating={4}
            image={imag5}
          />
        </div>

        
        <div className="home__row">
        <Product
            id="A19"
            title="Miles Morales Drop Shoulder Hoodie | FiberStore"
            price={4599}
            rating={5}
            image="https://img.ltwebstatic.com/images3_pi/2022/09/22/166381605848106bd9e508d6b617b2ae5ed87c268b_thumbnail_720x.webp"
          />
          <Product
            id="C22"
            title="Classic Beige Tuxedo | Firestore"
            price={8999}
            rating={5}
            image={imag4}
          />
         
        </div>

        <div className="home__row">
          <Product
            id="B20"
            title="Navy Blue Double-Breasted Camel Suit | Firestore"
            price={4999}
            rating={5}
            image={imag6}
          />
          <Product
            id="A21"
            title="Grey Herringbone Blazer | Firestore"
            price={7899.0}
            rating={4}
            image={imag7}
          />
          
        </div>
        <div className="home__row">
                    <Product
            id="B23"
            title="Influencer Series Men Printed Shirt From FiberStore"
            price={1699}
            rating={5}
            image="https://assets.myntassets.com/assets/images/21617996/2023/1/19/5c8eb4a7-50ef-46a3-9a12-5069559600fb1674135860723BlackInfluencePrintOversizeDropShoulderShirt1.jpg"
          />
                     <Product
            id="C24"
            title="Qutie Slogan Graphic Drop Shoulder Hoodie| FiberStore"
            price={2899}
            rating={5}
            image="https://img.ltwebstatic.com/images3_pi/2022/05/31/16539821481f99a2169058ea9f6ab49d3626a4fa9d_thumbnail_720x.webp"
          />
          </div>
      </div> 
    </div>
  );
}

export default Home;